import { Heading, Text, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

export const ReportGeneratorHeader: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <VStack space="stack.nano" width="full" flexShrink={0}>
      {isMobile ? (
        <Text fontSize="lg" variant="semibold">
          Gerador de relatórios
        </Text>
      ) : (
        <>
          <Heading testId="report-generator-title" size="h2">
            Gerador de relatórios
          </Heading>
          <Text fontSize="lg" color="neutral.dark" variant="light">
            Gere e baixe seus documentos de forma rápida e segura.
          </Text>
        </>
      )}
    </VStack>
  );
};
